module.exports = __webpack_public_path__ + "img/logo-pompiers.63b4851.webp";